export default __webpack_public_path__ + "static/media/ak.b120c066.jpg";